// Related via /recommendations/products (section rendering); recently viewed from the shopify_recently_viewed cookie,
// each handle fetched as a card through the same section (?view=card renders one card — see product-card view).
class ProductRecommendations extends HTMLElement {
  async connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-reco-tab]')];
    // Roving tabindex (WAI-ARIA tabs): Tab enters on the selected tab, arrows move between tabs.
    this.tabs.forEach((t) => {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', () => this.show(t.dataset.recoTab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
        const live = this.tabs.filter((x) => x.isConnected && !x.hidden); const i = live.indexOf(t); if (i < 0) return;
        const n = e.key === 'ArrowRight' ? live[(i + 1) % live.length] : e.key === 'ArrowLeft' ? live[(i - 1 + live.length) % live.length] : e.key === 'Home' ? live[0] : live[live.length - 1];
        e.preventDefault(); this.show(n.dataset.recoTab); n.focus();
      });
    });
    await Promise.all([this.loadRelated(), this.loadRecent()]);
    if (!this.querySelector('[data-reco-tab]:not([hidden])')) this.hidden = true;
  }
  async loadRelated() {
    const panel = this.querySelector('[data-reco-panel="related"]'); if (!panel) return;
    try {
      const html = new DOMParser().parseFromString(await (await fetch(this.dataset.url)).text(), 'text/html');
      const grid = html.querySelector('[data-api-content]');
      if (grid && grid.children.length) { panel.replaceChildren(grid); panel.removeAttribute('aria-busy'); return; }
    } catch (e) { /* fall through */ }
    panel.remove(); this.querySelector('[data-reco-tab="related"]')?.remove(); this.show('recent');
  }
  async loadRecent() {
    const panel = this.querySelector('[data-reco-panel="recent"]'); if (!panel) return;
    const m = document.cookie.match(/(?:^|; )shopify_recently_viewed=([^;]*)/);
    const handles = m ? decodeURIComponent(m[1]).split(' ').filter(Boolean).slice(0, 4) : [];
    const cards = await Promise.all(handles.map(async (h) => {
      try { const html = new DOMParser().parseFromString(await (await fetch(this.dataset.recentUrl.replace('HANDLE', h))).text(), 'text/html'); return html.querySelector('[data-card]')?.firstElementChild; } catch (e) { return null; }
    }));
    const found = cards.filter(Boolean);
    if (found.length) { panel.replaceChildren(...found); this.querySelector('[data-reco-tab="recent"]').hidden = false; }
    else { panel.remove(); this.querySelector('[data-reco-tab="recent"]')?.remove(); }
  }
  show(key) {
    this.tabs.forEach((t) => { const on = t.dataset.recoTab === key; t.classList.toggle('is-current', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
    this.querySelectorAll('[data-reco-panel]').forEach((p) => { p.hidden = p.dataset.recoPanel !== key; });
  }
}
if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
